import React from 'react';

import { FormControl, FormControlLabel, FormGroup } from '@mui/material';

import ItemInfo from './ItemInfo';
import {
  Divider,
  Container,
  SectionTitle,
  OrderNumber,
  ContentContainer,
  CustomCheckbox,
} from './styles';
import { CustomTextField } from '../../../../styles';
import usePageStore from '../../../../../../store/pageStore';
import useConfigsStore from '../../../../../../store/configsStore';

export default function ItemReasonsResolutionSelection({ item, itemStep }) {
  //!
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const itemReasons = useConfigsStore((state) => state.itemReasons);

  const formData = usePageStore((state) => state.formData);
  const setValidVtexOrderItemReason = usePageStore(
    (state) => state.setValidVtexOrderItemReason,
  );
  const setValidVtexOrderItemResolution = usePageStore(
    (state) => state.setValidVtexOrderItemResolution,
  );

  return (
    <Container>
      <OrderNumber primaryColor={devolutionPageConfigs?.primaryColor}>
        Pedido: #{formData.orderNumber}
      </OrderNumber>
      <ItemInfo key={item.uniqueId} itemData={item} />
      <Divider />
      {itemStep === 0 && (
        <>
          <SectionTitle> Selecione o motivo da devolução: </SectionTitle>
          <ContentContainer>
            <FormControl component="fieldset" variant="standard">
              <FormGroup>
                {itemReasons?.map(
                  (reason) =>
                    reason.isSelected && (
                      <FormControlLabel
                        key={reason.id}
                        control={
                          <CustomCheckbox
                            color={devolutionPageConfigs?.primaryColor}
                            checked={item.reason === reason.id}
                            onChange={() =>
                              setValidVtexOrderItemReason(reason.id)
                            }
                          />
                        }
                        label={reason.description}
                      />
                    ),
                )}
              </FormGroup>
            </FormControl>
          </ContentContainer>
        </>
      )}
      {itemStep === 1 && (
        <>
          <SectionTitle> Como você quer resolver o problema?: </SectionTitle>
          <ContentContainer>
            <CustomTextField
              value={item.resolution}
              onChange={(e) => {
                setValidVtexOrderItemResolution(e.target.value);
              }}
              type="text"
              bordercolor={
                devolutionPageConfigs?.fontColor || 'var(--color-blue-primary)'
              }
              fullWidth
              label="Resolução"
              variant="outlined"
              inputProps={{
                style: { fontFamily: devolutionPageConfigs?.fontFamily },
              }}
              InputLabelProps={{
                shrink: item.resolution,
                style: { fontFamily: devolutionPageConfigs?.fontFamily },
              }}
            />
          </ContentContainer>
        </>
      )}
    </Container>
  );
}
